module.exports = __webpack_public_path__ + "img/arrow-up.ee1d7866.png";